<template>
	<div class="fluid self_reported_courses w-100">

    <div class="courses_section" v-if="isCoursesLoaded">
      <template v-if="(educationReq.length > 0 && !$parent.isGuestLogin)">
        <div class="inst_list_container">
          <template v-for="(education, i) in educationReq">
            <div>
              <div class="row sec_hd" role="heading" tabindex="0">
                <div class="col-12 hd_txt">
                  <div>{{education.title}}</div>
                </div>
              </div>
              <div class="row sec_content">
                <div class="col-12 sec_txt">
                  <div>{{education.description}}</div>
                </div>
              </div>
              <div class="row sec_content">
                <div class="col-12 sec_txt">
                  <b-collapse visible :id="'institution-' + education.uuid">
                    <div class="course_list_container">
                      <span v-for="req in education.children" :key="req.originUuid">
                        <div class="row course_row">
													<div class="float-left text-center mr-3" style="width: 80px;">
														<div style="height: 50px; border-radius: 8px;">
															<div style="line-height: 50px; color: #fff;">
																<div style="height: 30px;" class="ico-job float-left" v-if="(req.entityType==='JOB')">
	                              </div>
	                              <div style="height: 30px;" class="ico-program float-left" v-if="(req.entityType==='PROGRAM')">
	                              </div>
	                              <div style="height: 30px;" class="ico-letter float-left" v-if="(req.entityType==='LETTER')">
	                              </div>
	                              <div style="height: 30px;" class="ico-catalog float-left" v-if="(req.entityType==='CATALOG')">
	                              </div>
															</div>
														</div>
													</div>
                          <div class="title col-6">
                            <div>
                              <div>
                                <div class="col_title" style="cursor: default !important; color: #5f5f5f !important;">
                                  {{req.title}}
                                </div>
                              </div>
                              <div>
                                <div class="description">
                                  {{req.description}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-2" v-if="req.courseGrade">
                            <div class="txt_container">
                              <span>
                                performance > {{req.courseGrade}}
                              </span>
                            </div>
                          </div>

                        </div>
                      </span>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import _ from 'lodash'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'program-education',
    props: ['pathwayId'],
    data () {
      return {
        educationReq: [],
        userId: localStore.getItem('userid'),
        username: localStore.getItem('userFullName'),
        isCoursesLoaded: false,
      }
    },
    mounted () {
      this.showLoader()
      this.loadEducationRequirement()
    },
    methods: {
      ...mapActions([
        'loadProgramEducation'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        return course.programCode
      },
      async loadEducationRequirement () {
        this.loadProgramEducation(this.pathwayId).then(result => {
          this.educationReq = result
          this.totalElements = result.length
          this.hideLoader()
          this.selected = [],
          this.isCoursesLoaded = true
        })
      },
      resetPage () {
        this.loadEducationRequirement()
      }
    }
  }
</script>

<style>
  .title-txt {
    color: #fff;
    margin-top: 3px;
    font-weight: 500;
    text-align: center;
  }

  div[id^="courseStatusPopup-"] .popover {
    transform: translate3d(-8px, 20px, 0px) !important;
    max-width: 220px !important;
    width: 220px !important;
    height: 225px !important;
    margin-top: 15px;
  }

  div[id^="courseStatusPopup-"] .popover .arrow {
    display: none !important;
  }

  .form-check-input {
    top: 12px;
    cursor: pointer;
  }

  .status-not-started {
    background: #b4b4b4 !important;
  }

  .status-in-progress {
    background: #dd9623 !important;
  }

  .status-completed {
    background: #0a7714 !important;
  }

  .status-not-completed {
    background: #f40909 !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/transfer/components/ProgramEducation.vue